// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__luKaz","popup__overlay":"Popup_popup__overlay__uB7D-","popup__content":"Popup_popup__content__3XHZW"};